module.exports = __webpack_public_path__ + "media/images/cta-arrow-5f4e5b025b245e3b4c470f4e1fb1a2e2.svg";